<template>
    <div class="text-uploader">
        <image-uploader hidden ref="uploader"></image-uploader>

        <a-button @click="call">open</a-button>
    </div>
</template>

<script type="text/ecmascript-6">
    import ImageUploader from '@/components/common/image-uploader.component';

    export default {
        name: 'Example-image-uploader',
        components: {
            ImageUploader
        },
        props: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
        },
        methods: {
            call() {
                this.$refs.uploader.invokeUpload((path, file, res) => {
                    console.log(path, file, res);
                });
            }
        },
    }
</script>

<style lang="scss">
</style>
